// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"b76fe2a410dd51363e98","883":"4af81d5f16c3ffa6c5dd"}[chunkId] + ".js";
};